import { render, staticRenderFns } from "./DictionaryUnitNames.vue?vue&type=template&id=3b62fc90&scoped=true&"
import script from "./DictionaryUnitNames.vue?vue&type=script&lang=js&"
export * from "./DictionaryUnitNames.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryUnitNames.vue?vue&type=style&index=0&id=3b62fc90&scoped=true&lang=scss&"
import style1 from "./DictionaryUnitNames.vue?vue&type=style&index=1&id=3b62fc90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b62fc90",
  null
  
)

export default component.exports